var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExplorer(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m117.52 114.7-12.72-14.84a21.51 21.51 0 1 0 -16.23 7.47 21.33 21.33 0 0 0 13.34-4.69l12.57 14.66a2 2 0 1 0 3-2.6zm-46.52-29.18a17.57 17.57 0 1 1 17.57 17.81 17.71 17.71 0 0 1 -17.57-17.81z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 89.28-5 3v-36.13l32-18.47v20.17a2 2 0 0 0 4 0v-24.45a2 2 0 0 0 -1-1.74l-36-20.78a2 2 0 0 0 -2 0l-36 20.78a2 2 0 0 0 -1 1.74v41.6a2 2 0 0 0 1 1.74l36 20.74a2 2 0 0 0 2 0l8-4.75a2 2 0 0 0 -2-3.44zm-7-74.36 32.71 18.88-32.71 18.89-32.71-18.89zm-34 22.76 32 18.47v36.14l-32-18.48z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorer);
export default __webpack_public_path__ + "static/media/explorer.5758052d665c16c40dc0c8a31d3b9f40.svg";
export { ForwardRef as ReactComponent };